import type { Tone } from '@folio/components/ui/tone';

export function getAlertListTone(listName: string): Tone {
  return listName.toLowerCase().includes('gel') ? 'destructive' : 'warning';
}

// @debt The backend stores pre-localized FR labels in `alert.data.lists` — both
// from super's CreateCheckModal (manual checks) and Efficiale's compliance
// provider (apps/legacy-service/src/compliance/efficiale-compliance-provider.ts).
// Until the back is migrated to emit codes, we shim the known labels here.
// Tracked in https://linear.app/korint/issue/ENG-3209
const ALERT_LIST_KEYS: Record<string, string> = {
  'Alerte PPE': 'ppe',
  'Alerte PPE National': 'ppe_nat',
  'Alerte PPE International': 'ppe_inter',
  'Bénéficiaires effectifs pour une entreprise': 'beneficiaries',
  'Gel des avoirs': 'gel',
};

export function getAlertListKey(listName: string): string | undefined {
  return ALERT_LIST_KEYS[listName];
}

export function getAccuracyTone(accuracy: number): Tone {
  if (accuracy >= 98) return 'destructive';
  if (accuracy >= 90) return 'warning';
  return 'muted';
}
